{
    "uk": {
        "Yes": "Так",
        "No": "Ні",
        "Cancel": "Скасувати",
        "Close": "Закрити",
        "Clear": "Очистити",
        "Done": "Готово",
        "Loading": "Завантаження...",
        "Select": "Вибрати...",
        "Search": "Пошук",
        "Back": "Назад",
        "OK": "OK",
        "dxCollectionWidget-noDataText": "Дані відсутні",
        "dxList-pullingDownText": "Потягніть вниз для оновлення...",
        "dxList-pulledDownText": "Відпустіть для оновлення...",
        "dxList-refreshingText": "Оновлення...",
        "dxList-pageLoadingText": "Завантаження...",
        "dxList-nextButtonText": "Більше",
        "dxList-selectAll": "Вибрати все",
        "dxDataGrid-noDataText": "Дані відсутні"
    }
}
